/**
 * Design tokens for code that cannot use a CSS variable — SVG geometry maths,
 * mostly. Colours are always referenced as `var(--…)` so the value itself only
 * ever lives in product/design-tokens.json.
 */
import { designTokens } from './contract'
import type { CategoryId } from '@/generated/types'

export const chart = designTokens.chart
export const layout = designTokens.layout
export const space = designTokens.space
export const motion = designTokens.motion

export type ScoreBand = 'poor' | 'fair' | 'good' | 'strong'

export const scoreBands = designTokens.scoreBand as Record<
  ScoreBand,
  { min: number; max: number; color: string; labelKey: string }
>

export function bandColorVar(band: ScoreBand): string {
  return `var(--score-${band})`
}

export function bandLabelKey(band: ScoreBand): string {
  return scoreBands[band].labelKey
}

export function categoryColorVar(category: CategoryId): string {
  return `var(--category-${category})`
}

export type SemanticColor =
  | 'primary'
  | 'accent'
  | 'positive'
  | 'caution'
  | 'danger'
  | 'info'
  | 'textPrimary'
  | 'textSecondary'
  | 'textTertiary'
  | 'moneyIn'
  | 'moneyOut'
  | 'chartGrid'
  | 'chartAxis'
  | 'border'
  | 'scoreTrack'
  | 'surface'
  | 'surfaceRaised'

export function colorVar(name: SemanticColor): string {
  return `var(--color-${name})`
}

/** Money direction -> the token that colours it. Positive is money in. */
export function moneyColorVar(amount: number): string {
  if (amount > 0) return colorVar('moneyIn')
  if (amount < 0) return colorVar('moneyOut')
  return colorVar('textSecondary')
}
